// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ORIk","label":"styles_label__2XONG"};